import styled from '@emotion/styled';

const ReleaseTitle = styled('h4')({
  marginBottom: 4,
});

export default ReleaseTitle;
